import { getNftCollectionStartTime } from '@ui/queries/types';
import type { NftCollection } from '@veno-app/sdk';
import { useEffect, useState } from 'react';

const useNftCollectionActive = (collection?: NftCollection) => {
  const [active, setActive] = useState(true);

  useEffect(() => {
    if (!collection) return;
    const startTime = getNftCollectionStartTime(collection);
    const endTime = getNftCollectionStartTime(collection);
    const now = new Date().getTime();
    let timeout: NodeJS.Timeout | null = null;

    if (endTime && endTime.getTime() < now) {
      setActive(false);
    } else if (startTime && startTime.getTime() > now) {
      setActive(false);
      timeout = setTimeout(() => setActive(true), startTime.getTime() - now);
    }
    return () => {
      if (timeout) clearTimeout(timeout);
    };
  }, [collection]);

  return active;
};

export default useNftCollectionActive;
